import { Link } from "react-router-dom";
import { Play } from "lucide-react";

export default function ShortsBlock({ shorts = [] }) {
  if (!shorts.length) return null;
  return (
    <section data-testid="shorts-block">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-headline uppercase text-xl md:text-2xl">
          <span className="accent-text">PO</span>PU SHORTS
        </h2>
        <Link to="/categoria/viral" className="text-sm font-semibold accent-text hover:underline" data-testid="shorts-ver-mas">
          Ver más →
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {shorts.slice(0, 3).map((s) => (
          <Link
            key={s.id}
            to={`/shorts/${s.slug}`}
            className="card-hover group relative block aspect-[9/16] rounded-sm overflow-hidden"
            style={{ background: "var(--surface-2)" }}
            data-testid={`short-${s.slug}`}
          >
            {s.featured_image && (
              <img
                src={s.featured_image}
                alt={s.title}
                className="card-img w-full h-full object-cover"
                loading="lazy"
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-12 h-12 rounded-full bg-white/85 backdrop-blur flex items-center justify-center shadow-lg group-hover:scale-110 transition">
                <Play size={20} className="text-black ml-0.5" fill="black" />
              </div>
            </div>
            {s.duration && (
              <span className="absolute top-2 right-2 px-2 py-0.5 bg-black/80 text-white text-xs font-bold rounded-sm">
                {s.duration}
              </span>
            )}
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="overline accent-text mb-1" style={{ color: "#FFB3D1" }}>POPU SHORT</p>
              <p className="text-white text-sm font-bold leading-tight line-clamp-2">{s.title}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
